import { render, staticRenderFns } from "./site-header.vue?vue&type=template&id=c880ce48&scoped=true&"
import script from "./site-header.vue?vue&type=script&lang=js&"
export * from "./site-header.vue?vue&type=script&lang=js&"
import style0 from "./site-header.vue?vue&type=style&index=0&id=c880ce48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c880ce48",
  null
  
)

export default component.exports